<template>
  <div>
    <footer>
      <div
        class="
          container
          w-full
          max-w-5xl
          mx-auto
          px-3
          py-8
          border-grey-light border-t-2 border-solid border-l-0 border-r-0 border-b-0
        "
      >
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full text-center md:text-left mb-3">
            <ul>
              <li class="inline-block w-40 mr-3">
                <a :href="linkQrApple" target="_blank">
                  <img src="/img/apple-store.png" />
                </a>
              </li>
              <li class="inline-block w-40">
                <a :href="linkQrAndroid" target="_blank">
                  <img src="/img/google-play.png" />
                </a>
              </li>
            </ul>
          </div>
          <div class="vx-col md:w-1/2 w-full text-center md:text-right text-black">
            <ul>
              <li class="inline-block">
                <router-link :to="{ name: 'avisoLegal' }" class="text-black mr-3">
                  {{ $t('public.AvisoLegal') }}
                </router-link>
              </li>
              <li class="inline-block">
                <router-link :to="{ name: 'cookies' }" class="text-black mr-3">
                  {{ $t('public.Cookies') }}
                </router-link>
              </li>
            </ul>
            <p class="font-bold mt-3">Barify © 2020</p>
          </div>
        </div>
      </div>
    </footer>
    <a class="contacto w-20 modal-open" @click="toggleModal" href="#" title="Contacta con el local" v-if="canModal"
      ><img src="/img/contact.png" />
    </a>
    <div
      class="modal opacity-0 pointer-events-none fixed w-full h-full top-0 left-0 flex items-center justify-center"
      v-if="canModal"
    >
      <div class="modal-overlay absolute w-full h-full bg-grey-light opacity-50" @click="toggleModal"></div>

      <div class="modal-container bg-white w-11/12 md:max-w-md mx-auto rounded-lg shadow-lg z-50 overflow-y-auto">
        <div
          class="
            modal-close
            absolute
            top-0
            right-0
            cursor-pointer
            flex flex-col
            items-center
            mt-4
            mr-4
            text-white text-sm
            z-50
          "
          @click="toggleModal"
        >
          <svg
            class="fill-current text-white"
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
          >
            <path
              d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
            ></path>
          </svg>
          <span class="text-sm">{{ $t('Cerrar') }}</span>
        </div>

        <!-- Add margin if you want to see some of the overlay behind the modal-->
        <div class="modal-content py-6 text-center px-6">
          <!--Title-->
          <div class="flex justify-end items-end text-right pb-3">
            <div class="modal-close cursor-pointer z-50" @click="toggleModal">
              <svg
                class="fill-current text-black"
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
              >
                <path
                  d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
                ></path>
              </svg>
            </div>
          </div>

          <!--Body-->
          <p class="text-xl font-bold text-center">{{ restaurant.name }}</p>
          <p class="text-sm">
            <font-awesome-icon :icon="['fas', 'map-marker-alt']" class="mr-2" />{{ restaurant.address }}
          </p>

          <p class="font-bold text-center mt-8">{{ $t('public.OpcionesDeContacto') }}</p>

          <div class="flex mt-6 justify-center">
            <div class="w-1/3" v-if="telContacto">
              <a :href="telContacto" target="_blank">
                <img src="/img/telefono.png" class="w-full" />
                <p class="text-sm font-bold">{{ $t('public.Telefono') }}</p>
              </a>
            </div>
            <div class="w-1/3" v-if="whatsappContacto">
              <a :href="whatsappContacto" target="_blank">
                <img src="/img/whatsapp.png" class="w-full" />
                <p class="text-sm font-bold">{{ $t('Whatsapp') }}</p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    restaurant: {
      type: Object,
    },
  },
  data () {
    return {
      linkQrAndroid: process.env.VUE_APP_LINK_ANDROID,
      linkQrApple: process.env.VUE_APP_LINK_APPLE,
    };
  },
  computed: {
    canModal () {
      if (this.restaurant) {
        if (Object.keys(this.restaurant).length && (this.restaurant.phone_bookings || this.restaurant.whatsapp)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    mailContacto () {
      if (this.restaurant.email) {
        return `mailto:${this.restaurant.email}`;
      } else {
        return '';
      }
    },
    telContacto () {
      if (this.restaurant.phone_bookings) {
        return `tel:${this.restaurant.phone_bookings}`;
      } else {
        return '';
      }
    },
    whatsappContacto () {
      if (this.restaurant.whatsapp) {
        return `https://api.whatsapp.com/send?phone=${this.restaurant.whatsapp}`;
      } else {
        return '';
      }
    },
  },
  methods: {
    toggleModal () {
      const body = document.querySelector('body');
      const modal = document.querySelector('.modal');
      modal.classList.toggle('opacity-0');
      modal.classList.toggle('pointer-events-none');
      body.classList.toggle('modal-active');
    },
  },
};

document.onkeydown = function (evt) {
  evt = evt || window.event;
  let isEscape = false;
  if ('key' in evt) {
    isEscape = evt.key === 'Escape' || evt.key === 'Esc';
  } else {
    isEscape = evt.keyCode === 27;
  }
  if (isEscape && document.body.classList.contains('modal-active')) {
    // toggleModal();
  }
};
</script>
<style>
.contacto {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9;
}
footer a {
  color: #ffffff !important;
}
</style>
